/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */ 

/* CUSTOM CONCRETE STUDIO */

/* CS - Pioggia di ciliegie - OLD 2023
$(document).ready(function() {
  // Impostare la velocità di caduta delle ciliegie
  var speed = 2; 
  
  // Creare una nuova ciliegia ogni 100 millisecondi
  setInterval(function() {
    var ciliegia = $('<div class="ciliegia"></div>');
    ciliegia.text('🍒');
    $('#pioggia-di-ciliegie').append(ciliegia);
    
    // Impostare la posizione iniziale della ciliegia in cima allo schermo e in una posizione casuale orizzontale
    ciliegia.css({
      'left': Math.random() * window.innerWidth,
      'top': '-50px'
    });
    
    // Animate la caduta della ciliegia verso il basso fino alla fine dell'area visualizzata ma prima del footer
    ciliegia.animate({
      top: $('body').height() - $('footer:not([data-exclude])').outerHeight() - ciliegia.outerHeight(),
    }, Math.random() * 15000 + speed * 1000, 'linear', function() {
      $(this).remove();
    });
  }, 100);
}); */


/* CS - Pioggia di ciliegie - NEW 2024 - Controllo range data per attivazione/disattivazione automatica */
$(document).ready(function() {
  // Funzione per controllare se la data corrente è all'interno dell'intervallo specificato
  function isDateInRange() {
    var dataCorrente = new Date();
    var dataInizio = new Date('2024-05-25T00:01:00');
    var dataFine = new Date('2024-05-31T23:59:00');
    return dataCorrente >= dataInizio && dataCorrente <= dataFine;
  }

  // Eseguire l'effetto pioggia di ciliegie solo se la data è nell'intervallo specificato
  if (isDateInRange()) {
    // Impostare la velocità di caduta delle ciliegie
    var velocita = 2; 
    
    // Creare una nuova ciliegia ogni 100 millisecondi
    setInterval(function() {
      var ciliegia = $('<div class="ciliegia"></div>');
      ciliegia.text('🍒');
      $('#pioggia-di-ciliegie').append(ciliegia);
      
      // Impostare la posizione iniziale della ciliegia in cima allo schermo e in una posizione casuale orizzontale
      ciliegia.css({
        'left': Math.random() * window.innerWidth,
        'top': '-50px'
      });
      
      // Animare la caduta della ciliegia verso il basso fino alla fine dell'area visualizzata ma prima del footer
      ciliegia.animate({
        top: $('body').height() - $('footer:not([data-exclude])').outerHeight() - ciliegia.outerHeight(),
      }, Math.random() * 15000 + velocita * 1000, 'linear', function() {
        $(this).remove();
      });
    }, 100);
  }
});

 



/* OPEN EXTERNAL LINK IN NEW TAB */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}


/* PRODUCT ACCORDION */
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
acc[i].addEventListener("click", function() {

var panel = this.nextElementSibling;
if (panel.style.maxHeight){
  panel.style.maxHeight = null;
} else {
  let active = document.querySelectorAll(".accordion-div .accordion.active");
  for(let j = 0; j < active.length; j++){
    active[j].classList.remove("active");
    active[j].nextElementSibling.style.maxHeight = null;
  }
  this.classList.toggle("active");
  panel.style.maxHeight = panel.scrollHeight + "px";
}
});
}
if(acc[0]) {
  acc[0].click(); // aprire il primo accordion al caricamento della pagina
}
